// firebase.config.js
export const firebaseConfig = {
  apiKey: "AIzaSyDX3-Vb4fmb-hhavH7hk5SzOppsxpycybw",
  authDomain: "www.diviseed.com",
  projectId: "diviseed-3b654",
  storageBucket: "diviseed-3b654.firebasestorage.app",
  messagingSenderId: "1096073543538",
  appId: "1:1096073543538:web:58707011513c0ad53fa7eb",
  measurementId: "G-5ZKHEJBX2V",
};
